export type FavoriteStackItem = {
  name: string;
  note: string;
};

export type Snippet = {
  id: string;
  title: string;
  kind: 'tip' | 'code';
  body: string;
  language?: string;
};

export type ExternalRec = {
  name: string;
  focus: string;
  href: string;
};

export type AffiliateStore = 'Shopee' | 'Tokopedia' | 'Amazon' | 'Alibaba';

export type GearItem = {
  name: string;
  category: string;
  note: string;
  links: Partial<Record<AffiliateStore, string>>;
};

export const favoriteStackData: FavoriteStackItem[] = [
  {
    name: 'Typescript + Hono + Tanstack Router + Anvia',
    note: 'Default for production full-stack AI applications that strong, fast, scalable and reliable',
  },
  {
    name: 'Next.js',
    note: 'Fast path from idea to shipped UI without fighting the type system. I only use this for small to medium scale',
  },
  {
    name: 'Python',
    note: 'Python is my go-to language for data analysis, automation, reporting, visualization, and building data-driven insights.',
  },
  {
    name: 'Langfuse',
    note: 'Agentic work without observability is just vibes. Traces keep me honest.',
  },
  {
    name: 'Figma/Excalidraw',
    note: 'I sketch systems before I code them. Shared pictures beat long threads.',
  },
];

export type DailyDriverApp = {
  name: string;
  category: 'IDE' | 'LLM' | 'AI Tools' | 'Git' | 'Deployment';
  href: string;
};

export const dailyDriverAppsData: DailyDriverApp[] = [
  { name: 'Zed', category: 'IDE', href: 'https://zed.dev' },
  { name: 'Cursor', category: 'IDE', href: 'https://cursor.com' },
  { name: 'Kimi 2.7 Code', category: 'LLM', href: 'https://kimi.com' },
  { name: 'GLM 5.5', category: 'LLM', href: 'https://z.ai' },
  {
    name: 'Claude Haiku',
    category: 'LLM',
    href: 'https://www.anthropic.com/claude/haiku',
  },
  { name: 'Groq 4.5', category: 'LLM', href: 'https://groq.com' },
  { name: 'Opencode', category: 'AI Tools', href: 'https://opencode.ai' },
  { name: 'OpenRouter', category: 'AI Tools', href: 'https://openrouter.ai' },
  { name: 'Dokploy', category: 'Deployment', href: 'https://dokploy.com' },
  { name: 'Fork', category: 'Git', href: 'https://fork.dev' },
];

export const snippetsData: Snippet[] = [
  {
    id: 'async-first',
    title: 'Write the decision, not the meeting',
    kind: 'tip',
    body: 'If a remote discussion needs a call, start with a short written proposal: context, options, recommendation. Meetings go faster when the thinking is already visible.',
  },
  {
    id: 'diagram-first',
    title: 'Diagram before the ticket',
    kind: 'tip',
    body: 'Before opening a PR for a change that spans services, I draw the request path on a whiteboard (or Excalidraw). Half the bugs die in that sketch.',
  },
  {
    id: 'guard-clause',
    title: 'Prefer early returns',
    kind: 'code',
    language: 'kotlin',
    body: `fun process(order: Order?): Result {
    if (order == null) return Result.Invalid("missing order")
    if (!order.isPaid) return Result.Invalid("unpaid")
    return Result.Ok(fulfill(order))
}`,
  },
  {
    id: 'sql-explain',
    title: 'Always EXPLAIN the scary query',
    kind: 'code',
    language: 'sql',
    body: `-- Before shipping a hot path query:
EXPLAIN ANALYZE
SELECT ...
WHERE ...;`,
  },
];

export const youtubeChannelsData: ExternalRec[] = [
  {
    name: 'Placeholder Channel One',
    focus: 'System design walkthroughs (dummy seed)',
    href: 'https://www.youtube.com/',
  },
  {
    name: 'Placeholder Channel Two',
    focus: 'Backend deep dives (replace with real pick)',
    href: 'https://www.youtube.com/',
  },
  {
    name: 'Placeholder Channel Three',
    focus: 'AI / LLM engineering (replace with real pick)',
    href: 'https://www.youtube.com/',
  },
];

export const blogsIReadData: ExternalRec[] = [
  {
    name: 'Placeholder Blog One',
    focus: 'Engineering essays I keep rereading (dummy seed)',
    href: 'https://example.com',
  },
  {
    name: 'Placeholder Blog Two',
    focus: 'Product + craft writing (replace with real pick)',
    href: 'https://example.com',
  },
  {
    name: 'Placeholder Blog Three',
    focus: 'Distributed systems notes (replace with real pick)',
    href: 'https://example.com',
  },
];

export const gearData: GearItem[] = [
  {
    name: 'Daily laptop (placeholder)',
    category: 'Laptop',
    note: 'Primary machine for coding, writing, and calls. Swap in the real model + links when ready.',
    links: {
      Shopee: '#',
      Tokopedia: '#',
      Amazon: '#',
      Alibaba: '#',
    },
  },
  {
    name: 'Mechanical keyboard (placeholder)',
    category: 'Keyboard',
    note: 'Dummy gear entry. Affiliate URLs are placeholders.',
    links: {
      Shopee: '#',
      Tokopedia: '#',
      Amazon: '#',
    },
  },
  {
    name: 'Monitor (placeholder)',
    category: 'Display',
    note: 'Dummy gear entry. Replace with the panel you actually use.',
    links: {
      Shopee: '#',
      Tokopedia: '#',
      Amazon: '#',
      Alibaba: '#',
    },
  },
  {
    name: 'Headphones (placeholder)',
    category: 'Audio',
    note: 'Dummy gear entry for focus blocks and calls.',
    links: {
      Shopee: '#',
      Tokopedia: '#',
      Amazon: '#',
    },
  },
];
